/**
 * Validation utilities for form fields
 */

/**
 * Validates if a string is a valid email address
 * @param email - The email string to validate
 * @returns true if valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return emailRegex.test(email);
}

/**
 * React Hook Form validator for email fields
 * Returns validation rules object for use with register()
 */
export const emailValidation = {
  required: 'Email is required',
  validate: (value: string) => isValidEmail(value) || 'Invalid email address',
};

/**
 * React Hook Form validator for optional email fields
 * Only validates format if a value is provided
 */
export const optionalEmailValidation = {
  validate: (value: string) => !value || isValidEmail(value) || 'Invalid email address',
};
